// extracted by mini-css-extract-plugin
export default {"p_tye":"fbf7f1aac7","slcted":"_67ebcad142","slc_color":"_417adca856","item_p":"abde72edb8","r0":"_4d78bcccfe"};